export class ApiClient {
  private readonly _baseUrl: string;
  private readonly _defaultHeaders: Record<string, string>;

  constructor(baseUrl: string) {
    this._baseUrl = baseUrl;
    this._defaultHeaders = {
      'Content-Type': 'application/json',
    };
  }

  async get<T>(endpoint: string): Promise<T> {
    const response = await fetch(`${this._baseUrl}${endpoint}`, {
      method: 'GET',
      headers: this._defaultHeaders,
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  async post<T>(endpoint: string): Promise<T> {
    const response = await fetch(`${this._baseUrl}${endpoint}`, {
      method: 'POST',
      headers: this._defaultHeaders,
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  get baseUrl() {
    return this._baseUrl;
  }
}
